import {useState, useEffect} from "react";

export const Bundler = () => {
  const [callForQuote] = useState(window.bundler.call_for_quote);
  const [bundlerData] = useState(window.bundler.data);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [selected, setSelected] = useState({});

  const formatPrice = (currency, price) => {
    const formattedPrice = new Intl.NumberFormat("en-EN", {
      style: "currency",
      currency: currency,
      currencyDisplay: "narrowSymbol",
    }).format(price);
    return formattedPrice;
  }; 

  const calculatePrice = () => {
    let price = Number(0);
    let foundItem;
    for (const value of Object.values(selected)) {
      const itemID = value;
      bundlerData.map((item) => {
        return (foundItem = item.product_data.map((product) => {
          if (product.id == itemID) {
            price = Number(price) + Number(product.price);
          }
        }));
      });
    }

    price > 0
      ? setPrice(formatPrice(Shopify.currency.active, price))
      : setPrice(0);
  };

  useEffect(() => {
    calculatePrice();
    return () => setPrice(0);
  }, [selected]);

  const addToCart = (event) => {
    event.preventDefault();
    setLoading(true);

    let data = {
      items: [],
    };

    const forms = document.querySelectorAll("form.bundles-form");
    forms.forEach((form) => {
      let formData = new FormData(form);

      if (formData.get("id") !== null) {
        data.items.push({
          id: formData.get("id"),
          quantity: formData.get("quantity"),
        });
      }
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              quantity: Object.values(data.items).reduce(
                (total, current) => Number(total) + Number(current.quantity),
                0
              ),
            },
          })
        );
        setTimeout(() => {
          setLoading(false);
        }, 1200);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const disabled = () => {
    return !!Object.keys(selected).length == 0;
  };

  const showContactForm = () => {
    document.getElementById("bundler").classList.add("hidden");

    // delegate to the main function that shows the form
    window.handleCAllForQuoteButton();
  };

  return (
    <div className="bundler max-w-[160rem] mx-auto mb-[50px]">
      {bundlerData.length ? (
        <div className="bundler__inner">
          {price != 0 && !callForQuote ? (
            <>
              <div className="price nli-cost">{price}</div>
              <hr className="my-6" />
            </>
          ) : (
            <div>
              <strong className="text-xl pr-2">From:</strong>{" "}
              <span className="price nli-cost">
                {formatPrice(
                  Shopify.currency.active,
                  window.bundler.from_price
                )}
              </span>
              <hr className="my-6" />
            </div>
          )}
          <div className="flex justify-between flex-wrap">
            {bundlerData.map((section, index) => {
              return (
                <div
                  key={section.section_title + index}
                  className="bundler__section-wrapper w-full"
                >
                  <form className="bundles-form">
                    <label
                      className="mb-[10px] block uppercase"
                      htmlFor={
                        section.section_title.replace(" ", "-") + "_Section"
                      }
                    >
                      {section.section_title}
                    </label>
                    <div className="flex mb-6 nli-product">
                      <select
                        className="rounded-md border border-black mr-4 p-3 w-[calc(100%-60px)] bundler-select"
                        name="id"
                        id={
                          section.section_title.replace(" ", "-") + "_Section"
                        }
                        defaultValue=""
                        onChange={(e) => {
                          let selected_object = Object.assign({}, selected);
                          selected_object["section_" + index] = {
                            id: e.target.value,
                          };
                          setSelected(selected_object);
                        }}
                      >
                        <option value="" disabled>
                          Choose an option
                        </option>
                        {section.product_data.map((product, index) => {
                          return product.id != "" ? (
                            <option
                              key={product.id + index}
                              value={product.id}
                              data-price={product.price}
                            >
                              {product.title} +${product.price}
                            </option>
                          ) : null;
                        })}
                      </select>
                      <input
                        className="rounded-md border border-black p-3 w-[60px]"
                        type="number"
                        id="qty"
                        name="quantity"
                        defaultValue="0"
                      />
                    </div>
                  </form>
                </div>
              );
            })}
          </div>
          <div className="flex justify-center">
            {!callForQuote ? (
              <button
                onClick={(event) => addToCart(event)}
                className={`border rounded-md w-full text-white px-5 py-3 ${
                  disabled()
                    ? "border-[#9CA3AF] bg-[#9CA3AF] cursor-not-allowed"
                    : " border-[#58913d] bg-[#58913d]"
                }`}
                disabled={disabled()}
              >
                {loading ? "ADDING!" : "ADD TO CART"}
              </button>
            ) : (
              <button
                className="border rounded-md w-full text-white product-form__add-button button button--primary call-for-quote-trigger"
                onClick={() => showContactForm()}
              >
                Call for quote
              </button>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};
